export default {"src":"/_next/static/media/Multiple Sclerosis.60135b6e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};